module.exports = __webpack_public_path__ + "static/media/nature_2.df608809.jpg";